export default "__VITE_ASSET__C6$FD7Wv__"